/* ============================================================
   VENTURE SOCKS — CART DRAWER LOGIC
   ============================================================
   Talks to Shopify's built-in AJAX Cart API (/cart.js,
   /cart/add.js, /cart/change.js) so it works regardless of
   how the rest of your theme is built.

   ---------------------------------------------------------
   EDIT THIS CONFIG BLOCK — everything you need to tune lives
   here. No need to touch anything below it.
   ---------------------------------------------------------
*/
window.VentureCartConfig = window.VentureCartConfig || {

  // ---- REWARD BARS ------------------------------------------------
  // Add, remove, or reorder tiers freely — the drawer renders
  // whatever's in this array, in order. Each entry needs a
  // unique "id".
  rewards: [

    {
      id: "free-shipping",
      type: "spend_threshold",
      label: "Free Shipping",
      // Simple line icon (not emoji) to match your monochrome cart —
      // swap for any inline SVG you like.
      icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4h13v11H1zM14 8h4l4 4v3h-8zM4.5 19.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17.5 19.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',

      // Threshold to unlock, keyed by 3-letter currency code.
      // Shopify's cart currency (cart.currency) already reflects
      // whatever country/currency the shopper has selected, so
      // this table doesn't need country codes — just currencies.
      // "default" is used for any currency not listed.
      thresholds: {
        GBP: 50,
        USD: 75,
        EUR: 60,
        default: 50
      },

      lockedMessage: "You're {remaining} away from <strong>FREE shipping</strong>",
      unlockedMessage: "Nice one — you've unlocked <strong>FREE shipping</strong>"
    },

    {
      id: "bogo",
      type: "bogo_quantity",
      label: "Buy 3 Get 1 Free",
      icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9h18v11H3zM3 9V6a2 2 0 012-2h14a2 2 0 012 2v3M12 4v16M8 9c0-2.2-1.5-4-3-4M16 9c0-2.2 1.5-4 3-4" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round"/></svg>',

      // How many items make one "bundle" (3 paid + 1 free = 4).
      bundleSize: 4,

      // Product types to EXCLUDE from the count, e.g. if the
      // promo is socks-only. Leave empty to count every item.
      // Example: excludeProductTypes: ["Coffee", "Accessories", "Gift Card"]
      excludeProductTypes: [],

      lockedMessage: "{remaining} more and your next pair's <strong>on us</strong>",
      unlockedMessage: "You've unlocked <strong>{count} free pair(s)</strong> — nice"
    }

    // Add another tier any time, e.g.:
    // {
    //   id: "free-gift",
    //   type: "spend_threshold",
    //   label: "Free Gift",
    //   icon: "✨",
    //   thresholds: { GBP: 90, USD: 120, EUR: 100, default: 90 },
    //   lockedMessage: "Spend {remaining} more for a free gift",
    //   unlockedMessage: "Your free gift is unlocked!"
    // }
  ],

  // Selector(s) that open the drawer. The script also always
  // listens for [data-vcd-open] and .vcd-open-trigger.
  openTriggerSelectors: ["[data-vcd-open]", ".vcd-open-trigger"],

  // Auto-open the drawer whenever something is added to cart.
  autoOpenOnAdd: true,

  // ---- PRODUCT RECOMMENDATIONS / UPSELL ---------------------------
  upsell: {
    enabled: true,
    label: "You need these too",
    buttonText: "Add",
    maxProducts: 3
    // Uses Shopify's built-in /recommendations/products.json based on
    // the last item added to the cart. No app or config needed.
  },

  // ---- GIFT WRAPPING ------------------------------------------------
  giftWrap: {
    enabled: false, // not offering gift wrapping — set true and fill in variantId below if that changes
    label: "Add gift wrapping",

    // REQUIRED — set this to the numeric variant ID of your gift-wrap
    // product. Find it in Admin → Products → your gift wrap product →
    // it's the number in the URL, or in the variant's "..." menu.
    // Leave as null to hide this row entirely until you set it.
    variantId: null,

    // Optional: shown next to the label, e.g. "+ £2.50". Leave null
    // to read the price live from the product instead.
    priceOverride: null
  },

  // ---- ORDER NOTE -----------------------------------------------
  orderNote: {
    enabled: true,
    label: "Add an order note",
    placeholder: "Add a note to your order",
    debounceMs: 600
  },

  // ---- DISCOUNT CODE BOX -----------------------------------------
  // Shopify's AJAX Cart API can't validate discount codes client-side
  // (that only happens at checkout) — this mirrors Qikify's own
  // behaviour: it applies the code to the session so it's ready at
  // checkout, and is upfront that it can't confirm validity yet.
  discountCode: {
    enabled: true,
    label: "Apply Discount",
    placeholder: "Enter discount code here",
    saveButtonText: "Save",
    appliedNote: "Added — this code is only verified at checkout"
  },

  // ---- TRUST BADGES ------------------------------------------------
  trustBadges: {
    enabled: true,
    // Add your own payment icon image paths here, e.g. using Shopify
    // asset URLs once uploaded: "{{ 'visa.svg' | asset_url }}".
    // Left empty by default so nothing broken renders until you do.
    icons: []
    // icons: [
    //   { src: "https://cdn.shopify.com/.../visa.svg", alt: "Visa" },
    //   { src: "https://cdn.shopify.com/.../paypal.svg", alt: "PayPal" }
    // ]
  }
};

// Picks up the real, theme-hosted icon URLs set by venture-cart-drawer.liquid
// (asset_url only works inside .liquid files, not here). If that inline
// script didn't run for some reason, this quietly falls back to the
// empty array above and the trust badge row just stays hidden.
if (window.VentureCartTrustBadgeIcons && window.VentureCartTrustBadgeIcons.length) {
  window.VentureCartConfig.trustBadges.icons = window.VentureCartTrustBadgeIcons;
}


(function () {
  "use strict";

  var CONFIG = window.VentureCartConfig;
  var root = document.getElementById("venture-cart-drawer");
  if (!root) return;

  var els = {
    root: root,
    overlay: root.querySelector("[data-vcd-close].vcd__overlay") || root.querySelector(".vcd__overlay"),
    items: root.querySelector("[data-vcd-items]"),
    empty: root.querySelector("[data-vcd-empty]"),
    footer: root.querySelector("[data-vcd-footer]"),
    count: root.querySelector("[data-vcd-count]"),
    subtotal: root.querySelector("[data-vcd-subtotal]"),
    rewards: root.querySelector("[data-vcd-rewards]"),
    checkout: root.querySelector("[data-vcd-checkout]"),

    upsellWrap: root.querySelector("[data-vcd-upsell]"),
    upsellLabel: root.querySelector("[data-vcd-upsell-label]"),
    upsellList: root.querySelector("[data-vcd-upsell-list]"),

    giftwrapWrap: root.querySelector("[data-vcd-giftwrap]"),
    giftwrapToggle: root.querySelector("[data-vcd-giftwrap-toggle]"),
    giftwrapLabel: root.querySelector("[data-vcd-giftwrap-label]"),
    giftwrapPrice: root.querySelector("[data-vcd-giftwrap-price]"),

    noteWrap: root.querySelector("[data-vcd-note-wrap]"),
    noteToggle: root.querySelector("[data-vcd-note-toggle]"),
    noteLabel: root.querySelector("[data-vcd-note-label]"),
    noteInput: root.querySelector("[data-vcd-note-input]"),

    discountWrap: root.querySelector("[data-vcd-discount-wrap]"),
    discountToggle: root.querySelector("[data-vcd-discount-toggle]"),
    discountLabel: root.querySelector("[data-vcd-discount-label]"),
    discountPanel: root.querySelector("[data-vcd-discount-panel]"),
    discountInput: root.querySelector("[data-vcd-discount-input]"),
    discountSave: root.querySelector("[data-vcd-discount-save]"),
    discountNote: root.querySelector("[data-vcd-discount-note]"),

    trust: root.querySelector("[data-vcd-trust]")
  };

  var currentCart = null;
  var lastUpsellProductId = null;
  var noteDebounceTimer = null;

  // ---------------------------------------------------------
  // Money formatting
  // ---------------------------------------------------------
  function formatMoney(cents, currencyCode) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode || "GBP",
        currencyDisplay: "narrowSymbol"
      }).format(amount);
    } catch (e) {
      return (currencyCode || "") + " " + amount.toFixed(2);
    }
  }

  // ---------------------------------------------------------
  // Reward bar engine
  // ---------------------------------------------------------
  function calcSpendThreshold(reward, cart) {
    var threshold = reward.thresholds[cart.currency] != null
      ? reward.thresholds[cart.currency]
      : reward.thresholds.default;

    var thresholdCents = threshold * 100;
    var total = cart.total_price; // cents, after cart-level discounts
    var unlocked = total >= thresholdCents;
    var percent = Math.min(100, Math.round((total / thresholdCents) * 100));

    var message;
    if (unlocked) {
      message = reward.unlockedMessage;
    } else {
      var remaining = formatMoney(thresholdCents - total, cart.currency);
      message = reward.lockedMessage.replace("{remaining}", "<strong>" + remaining + "</strong>");
    }

    return { unlocked: unlocked, percent: percent, message: message, segments: 0 };
  }

  function calcBogoQuantity(reward, cart) {
    var qty = 0;
    cart.items.forEach(function (item) {
      var excluded = reward.excludeProductTypes.indexOf(item.product_type) !== -1;
      if (!excluded) qty += item.quantity;
    });

    var bundle = reward.bundleSize;
    var remainderInBundle = qty % bundle;
    var freeUnlockedCount = Math.floor(qty / bundle);
    var unlocked = qty > 0 && remainderInBundle === 0;
    var remaining = unlocked ? 0 : bundle - remainderInBundle;

    // Percent fill within the CURRENT bundle in progress
    var percent = qty === 0 ? 0 : Math.round((remainderInBundle / bundle) * 100);
    if (unlocked) percent = 100;

    var message;
    if (freeUnlockedCount > 0) {
      message = reward.unlockedMessage.replace("{count}", freeUnlockedCount);
      if (!unlocked) {
        // mid-way through the NEXT bundle after already unlocking one
        message += " " + reward.lockedMessage.replace("{remaining}", "<strong>" + remaining + "</strong>");
      }
    } else {
      message = reward.lockedMessage.replace("{remaining}", "<strong>" + remaining + "</strong>");
    }

    return { unlocked: freeUnlockedCount > 0, percent: percent, message: message, segments: bundle };
  }

  function renderRewards(cart) {
    if (!els.rewards) return;
    els.rewards.innerHTML = CONFIG.rewards.map(function (reward) {
      var result;
      if (reward.type === "spend_threshold") {
        result = calcSpendThreshold(reward, cart);
      } else if (reward.type === "bogo_quantity") {
        result = calcBogoQuantity(reward, cart);
      } else {
        return "";
      }

      var segmentsHtml = "";
      if (result.segments > 1) {
        segmentsHtml = '<div class="vcd-reward__segments">' +
          new Array(result.segments).fill("<span></span>").join("") +
          "</div>";
      }

      // Message sits above a bar with a fixed circular icon badge at
      // the end (grey while locked, solid black once unlocked) —
      // matches the Qikify reference rather than a separate label row.
      return (
        '<div class="vcd-reward' + (result.unlocked ? " is-unlocked" : "") + '" data-vcd-reward="' + reward.id + '" aria-label="' + reward.label + '">' +
          '<div class="vcd-reward__message">' + result.message + "</div>" +
          '<div class="vcd-reward__bar-row">' +
            '<div class="vcd-reward__track">' +
              '<div class="vcd-reward__fill" style="width:' + result.percent + '%"></div>' +
              segmentsHtml +
            "</div>" +
            '<div class="vcd-reward__badge">' + reward.icon + "</div>" +
          "</div>" +
        "</div>"
      );
    }).join("");
  }

  // ---------------------------------------------------------
  // Cart items rendering
  // ---------------------------------------------------------
  function renderItems(cart) {
    if (cart.items.length === 0) {
      els.items.innerHTML = "";
      els.empty.hidden = false;
      els.footer.style.display = "none";
      return;
    }

    els.empty.hidden = true;
    els.footer.style.display = "";

    els.items.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_120x$1$2") : "";
      var variantLine = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";

      return (
        '<li class="vcd-item" data-vcd-line="' + (index + 1) + '" data-vcd-key="' + item.key + '">' +
          '<img class="vcd-item__image" src="' + image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
          '<div class="vcd-item__info">' +
            '<a class="vcd-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + "</a>" +
            (variantLine ? '<p class="vcd-item__variant">' + escapeHtml(variantLine) + "</p>" : "") +
            '<div class="vcd-item__qty">' +
              '<button type="button" data-vcd-qty-minus aria-label="Decrease quantity">&minus;</button>' +
              "<span>" + item.quantity + "</span>" +
              '<button type="button" data-vcd-qty-plus aria-label="Increase quantity">+</button>' +
            "</div>" +
          "</div>" +
          '<div class="vcd-item__side">' +
            '<button type="button" class="vcd-item__remove" data-vcd-remove aria-label="Remove item">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M2 4h12M6.5 4V2.5a1 1 0 011-1h1a1 1 0 011 1V4M3.5 4l.6 8.4a1 1 0 001 .9h5.8a1 1 0 001-.9L12.5 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
              "</svg>" +
            "</button>" +
            '<p class="vcd-item__price">' + formatMoney(item.final_line_price, cart.currency) + "</p>" +
          "</div>" +
        "</li>"
      );
    }).join("");
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  // ---------------------------------------------------------
  // Upsell / recommendations
  // Uses Shopify's built-in recommendations endpoint, seeded from
  // the most recent item in the cart. Refetches only when that
  // reference product changes, not on every quantity tweak.
  // ---------------------------------------------------------
  function renderUpsell(cart) {
    if (!CONFIG.upsell.enabled || !els.upsellWrap) return;

    if (cart.items.length === 0) {
      els.upsellWrap.hidden = true;
      return;
    }

    var referenceProductId = cart.items[cart.items.length - 1].product_id;
    if (referenceProductId === lastUpsellProductId) return; // avoid refetch spam
    lastUpsellProductId = referenceProductId;

    var url = "/recommendations/products.json?product_id=" + referenceProductId +
      "&limit=" + (CONFIG.upsell.maxProducts + cart.items.length) + "&intent=related";

    fetch(url, { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var cartProductIds = cart.items.map(function (i) { return i.product_id; });
        var products = (data.products || [])
          .filter(function (p) { return cartProductIds.indexOf(p.id) === -1; })
          .slice(0, CONFIG.upsell.maxProducts);

        if (products.length === 0) {
          els.upsellWrap.hidden = true;
          return;
        }

        els.upsellLabel.textContent = CONFIG.upsell.label;
        els.upsellWrap.hidden = false;

        els.upsellList.innerHTML = products.map(function (product) {
          var variant = product.variants[0];
          var image = product.featured_image ? product.featured_image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_120x$1$2") : "";
          return (
            '<div class="vcd-upsell-item">' +
              '<img class="vcd-upsell-item__image" src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
              '<div>' +
                '<p class="vcd-upsell-item__title">' + escapeHtml(product.title) + "</p>" +
                '<p class="vcd-upsell-item__price">' + formatMoney(variant.price, currentCart.currency) + "</p>" +
              "</div>" +
              '<button type="button" class="vcd-upsell-item__add" data-vcd-upsell-add="' + variant.id + '" ' + (variant.available ? "" : "disabled") + '>' +
                (variant.available ? CONFIG.upsell.buttonText : "Sold out") +
              "</button>" +
            "</div>"
          );
        }).join("");
      })
      .catch(function (err) { console.error("Venture cart upsell fetch failed", err); });
  }

  // ---------------------------------------------------------
  // Gift wrapping
  // ---------------------------------------------------------
  function findGiftWrapLine(cart) {
    if (!CONFIG.giftWrap.variantId) return null;
    return cart.items.find(function (item) {
      return String(item.variant_id) === String(CONFIG.giftWrap.variantId);
    }) || null;
  }

  function renderGiftWrap(cart) {
    if (!CONFIG.giftWrap.enabled || !els.giftwrapWrap) return;
    if (!CONFIG.giftWrap.variantId) {
      els.giftwrapWrap.hidden = true; // not configured yet — stay out of the way
      return;
    }

    els.giftwrapWrap.hidden = false;
    els.giftwrapLabel.textContent = CONFIG.giftWrap.label;

    var line = findGiftWrapLine(cart);
    els.giftwrapToggle.checked = !!line;

    if (CONFIG.giftWrap.priceOverride) {
      els.giftwrapPrice.textContent = CONFIG.giftWrap.priceOverride;
    } else if (line) {
      els.giftwrapPrice.textContent = formatMoney(line.final_price, cart.currency);
    } else {
      els.giftwrapPrice.textContent = "";
    }
  }

  function toggleGiftWrap(checked) {
    if (checked) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: CONFIG.giftWrap.variantId, quantity: 1 })
      }).then(refresh);
    } else {
      var line = findGiftWrapLine(currentCart);
      if (line) changeLine(line.key, 0).then(render);
    }
  }

  // ---------------------------------------------------------
  // Order note
  // ---------------------------------------------------------
  function setupOrderNote(cart) {
    if (!CONFIG.orderNote.enabled || !els.noteWrap) return;
    els.noteWrap.hidden = false;
    els.noteLabel.textContent = CONFIG.orderNote.label;
    els.noteInput.placeholder = CONFIG.orderNote.placeholder;
    if (document.activeElement !== els.noteInput) {
      els.noteInput.value = cart.note || "";
    }
  }

  function saveOrderNote(value) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: value })
    });
  }

  // ---------------------------------------------------------
  // Discount code box
  // ---------------------------------------------------------
  function setupDiscountBox() {
    if (!CONFIG.discountCode.enabled || !els.discountWrap) return;
    els.discountWrap.hidden = false;
    els.discountLabel.textContent = CONFIG.discountCode.label;
    els.discountInput.placeholder = CONFIG.discountCode.placeholder;
    els.discountSave.textContent = CONFIG.discountCode.saveButtonText;
  }

  function applyDiscountCode(code) {
    if (!code) return;
    // Sets Shopify's discount cookie for this session so it's ready
    // at checkout. Can't be verified or reflected in cart totals here
    // — only checkout can confirm a code is valid.
    fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" })
      .then(function () {
        els.discountNote.textContent = CONFIG.discountCode.appliedNote;
        els.discountNote.hidden = false;
      })
      .catch(function (err) { console.error("Venture cart discount apply failed", err); });
  }

  // ---------------------------------------------------------
  // Trust badges
  // ---------------------------------------------------------
  function renderTrustBadges() {
    if (!CONFIG.trustBadges.enabled || !els.trust) return;
    if (!CONFIG.trustBadges.icons.length) {
      els.trust.hidden = true;
      return;
    }
    els.trust.hidden = false;
    els.trust.innerHTML = CONFIG.trustBadges.icons.map(function (icon) {
      return '<img src="' + icon.src + '" alt="' + escapeHtml(icon.alt || "") + '" loading="lazy">';
    }).join("");
  }

  // ---------------------------------------------------------
  // Full render
  // ---------------------------------------------------------
  function render(cart) {
    currentCart = cart;
    els.count.textContent = cart.item_count;
    els.subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    renderRewards(cart);
    renderItems(cart);
    renderUpsell(cart);
    renderGiftWrap(cart);
    setupOrderNote(cart);
  }

  // ---------------------------------------------------------
  // Cart API calls
  // ---------------------------------------------------------
  function fetchCart() {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetchCart().then(render);
  }

  // ---------------------------------------------------------
  // Open / close
  // ---------------------------------------------------------
  function openDrawer() {
    els.root.classList.add("is-open");
    els.root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    refresh();
  }

  function closeDrawer() {
    els.root.classList.remove("is-open");
    els.root.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  window.VentureCart = { open: openDrawer, close: closeDrawer, refresh: refresh };

  // ---------------------------------------------------------
  // Event delegation
  // ---------------------------------------------------------
  document.addEventListener("click", function (e) {
    var closeTarget = e.target.closest("[data-vcd-close]");
    if (closeTarget) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var openTarget = e.target.closest(CONFIG.openTriggerSelectors.join(","));
    if (openTarget) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var minusBtn = e.target.closest("[data-vcd-qty-minus]");
    var plusBtn = e.target.closest("[data-vcd-qty-plus]");
    var removeBtn = e.target.closest("[data-vcd-remove]");

    if (minusBtn || plusBtn || removeBtn) {
      var li = e.target.closest("[data-vcd-key]");
      var key = li.getAttribute("data-vcd-key");
      var currentQty = parseInt(li.querySelector(".vcd-item__qty span").textContent, 10);
      var newQty = removeBtn ? 0 : (plusBtn ? currentQty + 1 : currentQty - 1);
      changeLine(key, newQty).then(render);
      return;
    }

    var upsellAddBtn = e.target.closest("[data-vcd-upsell-add]");
    if (upsellAddBtn && !upsellAddBtn.disabled) {
      var variantId = upsellAddBtn.getAttribute("data-vcd-upsell-add");
      upsellAddBtn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(refresh);
      return;
    }

    if (els.noteToggle && e.target.closest("[data-vcd-note-toggle]")) {
      els.noteInput.hidden = !els.noteInput.hidden;
      if (!els.noteInput.hidden) els.noteInput.focus();
      return;
    }

    if (els.discountToggle && e.target.closest("[data-vcd-discount-toggle]")) {
      els.discountPanel.hidden = !els.discountPanel.hidden;
      if (!els.discountPanel.hidden) els.discountInput.focus();
      return;
    }

    if (els.discountSave && e.target.closest("[data-vcd-discount-save]")) {
      applyDiscountCode(els.discountInput.value.trim());
      return;
    }
  });

  document.addEventListener("change", function (e) {
    if (els.giftwrapToggle && e.target === els.giftwrapToggle) {
      toggleGiftWrap(e.target.checked);
    }
  });

  document.addEventListener("input", function (e) {
    if (els.noteInput && e.target === els.noteInput) {
      clearTimeout(noteDebounceTimer);
      var value = e.target.value;
      noteDebounceTimer = setTimeout(function () { saveOrderNote(value); }, CONFIG.orderNote.debounceMs);
    }
  });

  // Escape key closes drawer
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  // ---------------------------------------------------------
  // Intercept native add-to-cart forms so the drawer opens
  // automatically, wherever those forms live in the theme.
  // ---------------------------------------------------------
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form.tagName === "FORM" && form.action && form.action.indexOf("/cart/add") !== -1)) return;

    e.preventDefault();
    var formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (CONFIG.autoOpenOnAdd) {
          openDrawer();
        } else {
          refresh();
        }
      })
      .catch(function (err) {
        console.error("Venture cart add failed", err);
        form.submit(); // fall back to normal page behaviour
      });
  });

  // One-time setup for sections that don't depend on cart contents
  setupDiscountBox();
  renderTrustBadges();

  // Initial silent fetch so the count badge is correct on page load
  fetchCart().then(render);
})();
